export const ORDER_SETTINGS_SAVE_ERROR =
  'There was an error when trying to save. Please, try again. If it continues failing, please contact support.';
